import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroInsuranceConfirmationPage } from './intro-insurance-confirmation';
import {DirectivesModule} from "../../directives/directives.module";
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    IntroInsuranceConfirmationPage,
  ],
  imports: [
    IonicPageModule.forChild(IntroInsuranceConfirmationPage),
    DirectivesModule,
    PipesModule,
  ],
})
export class IntroInsuranceConfirmationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-insurance-confirmation/intro-insurance-confirmation.module.ts